import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Column from '../../../bootstrap/component/Column'
import Row from '../../../bootstrap/component/Row'
import Radio from '../../../form/component/Radio'
import store from '../../../store'
import { selectProcessInstance } from '../../../process/state/instance-detail/selector'


const Instruction = ({ title, changeInstruction, instructionList, name, valueList, readOnly, labelList, saveTreatmentPlan }) => {
    const onChange = (name, value) => {
        changeInstruction(name, value)
        saveTreatmentPlan()
    }

    const state = store.getState()
    const processInstance = selectProcessInstance(state)
    const _readOnly = readOnly || (processInstance.processName === 'salesorder-set' && name === 'ipr')

    return (
        <Row top="S">
            <Column size={3}>
                {title}
            </Column>
            <Column size={2}>
                <Radio
                    onChange={onChange}
                    value={valueList[0]}
                    name={name}
                    readOnly={_readOnly}
                    object={instructionList}>
                    &#160;{labelList[0]}
                </Radio>
            </Column>
            <Column size={2}>
                <Radio
                    onChange={onChange}
                    name={name}
                    readOnly={_readOnly}
                    value={valueList[1]}
                    object={instructionList}>
                    &#160;{labelList[1]}
                </Radio>
            </Column>
            <Column size={3}>
                <Radio onChange={onChange}
                       name={name}
                       readOnly={_readOnly}
                       value={valueList[2]}
                       object={instructionList}>
                    &#160;{labelList[2]}
                </Radio>
            </Column>
            <Column size={2}/>
        </Row>
    )
}


const MAINTAIN_LIST = [
    'maintain',
    'improve',
    'idealize',
]

const YES_NO_LIST = [
    'yes',
    'no',
    'only_if_needed',
]

const YES_NO_LABEL_LIST = [
    'yes',
    'no',
    'only if needed',
]

const INSTRUCTION_FIELD_LIST = [
    {
        title: 'Upper midline',
        name: 'upperMidline',
        valueList: MAINTAIN_LIST,
        labelList: MAINTAIN_LIST,
    },
    {
        title: 'Lower midline',
        name: 'lowerMidline',
        valueList: MAINTAIN_LIST,
        labelList: MAINTAIN_LIST,
    },
    {
        title: 'Overjet',
        name: 'overjet',
        valueList: MAINTAIN_LIST,
        labelList: MAINTAIN_LIST,
    },
    {
        title: 'Overbite',
        name: 'overbite',
        valueList: MAINTAIN_LIST,
        labelList: MAINTAIN_LIST,
    },
    {
        title: 'Arch form',
        name: 'archForm',
        valueList: MAINTAIN_LIST,
        labelList: MAINTAIN_LIST,
    },
    {
        title: 'Canine relationship',
        name: 'canineRelationship',
        valueList: MAINTAIN_LIST,
        labelList: MAINTAIN_LIST,
    },
    {
        title: 'Procline',
        name: 'procline',
        valueList: YES_NO_LIST,
        labelList: YES_NO_LABEL_LIST,
    },
    {
        title: 'Expand',
        name: 'expand',
        valueList: YES_NO_LIST,
        labelList: YES_NO_LABEL_LIST,
    },
    {
        title: 'Distalize',
        name: 'distalize',
        valueList: YES_NO_LIST,
        labelList: YES_NO_LABEL_LIST,
    },
    {
        title: 'IPR',
        name: 'ipr',
        valueList: YES_NO_LIST,
        labelList: YES_NO_LABEL_LIST,
    },
]

const InstructionList = ({ treatmentPlan, changeTreatmentPlan, readOnly, changeInstruction, saveTreatmentPlan }) => {
    const { instructionList } = treatmentPlan

    return (
        <div className="instructions">
            <ContentBox title="Instructions">
                {INSTRUCTION_FIELD_LIST.map(instruction => {
                    return <Instruction
                        changeInstruction={changeInstruction}
                        instructionList={instructionList}
                        {...instruction}
                        readOnly={readOnly}
                        key={instruction.name}
                        saveTreatmentPlan={saveTreatmentPlan}
                    />
                })}

            </ContentBox>
        </div>
    )
}


InstructionList.propTypes = {
    treatmentPlan: PropTypes.object.isRequired,
    readOnly: PropTypes.bool.isRequired,
    changeInstruction: PropTypes.func.isRequired,
    saveTreatmentPlan: PropTypes.func.isRequired,
    changeTreatmentPlan: PropTypes.func.isRequired,
}

export default InstructionList



// WEBPACK FOOTER //
// ./src/modules/treatment/component/plan/InstructionList.js